import React from "react";
import { styled } from "@mui/material/styles";

import clsx from "clsx";
import logo_eparts_explorer from "../../../../assets/images/logo-eparts.svg";
import logo_eparts from "../../../../assets/images/logo-eparts.svg";
import logo_kt from "../../../../../assets/images/logo-kt.svg";
import Hidden from "@mui/material/Hidden";

import { colors, Link } from "@mui/material";
import { wrap } from "module";
import { MiscSavio, StyleguideSavioColors } from "../../../configuration/themeSettings";

export const Root = styled("footer", { label: "AppFooter-root" })(
  ({ theme }) => ({
    backgroundColor: theme.palette.footer.main,
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    color: StyleguideSavioColors.text.black,
    padding: theme.spacing(1),
    fontSize: 10,
    height: 50,
    alignItems: "center",
    zIndex: 1,

    '@media print': {
      display: 'none !important',
    }
  })
);

export const GroupLogo = styled("img", { label: "AppFooter-group-logo" })(
  ({ theme }) => ({
    height: 20,
    marginTop: 3,
  })
);
export const Divisory = styled("div", { label: "AppFooter-divisory" })(
  ({ theme }) => ({
    height: 20, width: 1, backgroundColor: "black", marginLeft: 10, marginRight: 5, minWidth: 1,
  })
);
export const Copyright = styled("div", { label: "AppFooter-copyright" })(
  ({ theme }) => ({
    flexGrow: 1,
  })
);
export const Credits = styled("div", { label: "AppFooter-credits" })(
  ({ theme }) => ({


    "img": {
      maxHeight: 10,
    },
    "a": {
      display: 'flex',
      alignItems: "center",
      textDecoration: "none",
      fontSize: 11,
      color: StyleguideSavioColors.text.black,
      wrap: 'nowrap',

      "span": {
        whiteSpace: "nowrap",
        //marginRight:5,
        '&:first-of-type': {
          paddingRight: 10,
          fontSize: 10,
        }
      }
    },
  })
);

export const FooterContainer = styled("div", { label: "AppFooter-footerContainer" })(
  ({ theme }) => ({
    display: 'flex',
    maxWidth: MiscSavio.maxWidthSite,
    width: '100%',
    alignItems: 'center',
  })
);

